<span class="ant-input-wrapper ant-input-group" *ngIf="isAddOn">
  <span class="ant-input-group-addon" *ngIf="dwAddOnBefore || dwAddOnBeforeIcon">
    <i [ngClass]="dwAddOnBeforeIcon" *ngIf="dwAddOnBeforeIcon"></i>
    <ng-container *ngIf="isAddOnBeforeString; else addOnBeforeTemplate">{{ dwAddOnBefore }}</ng-container>
    <ng-template #addOnBeforeTemplate>
      <ng-template [ngTemplateOutlet]="dwAddOnBefore"></ng-template>
    </ng-template>
  </span>
  <ng-template [ngIf]="!isAffix" *ngTemplateOutlet="contentTemplate"></ng-template>
  <span class="ant-input-affix-wrapper" [class.ant-input-affix-wrapper-sm]="isSmall" [class.ant-input-affix-wrapper-lg]="isLarge" *ngIf="isAffix">
    <ng-template *ngTemplateOutlet="affixTemplate"></ng-template>
  </span>
  <span class="ant-input-group-addon" *ngIf="dwAddOnAfter || dwAddOnAfterIcon">
    <i [ngClass]="dwAddOnAfterIcon" *ngIf="dwAddOnAfterIcon"></i>
    <ng-container *ngIf="isAddOnAfterString; else addOnAfterTemplate">{{ dwAddOnAfter }}</ng-container>
    <ng-template #addOnAfterTemplate>
      <ng-template [ngTemplateOutlet]="dwAddOnAfter"></ng-template>
    </ng-template>
  </span>
</span>
<ng-container *ngIf="isAffix && !isAddOn">
  <ng-template *ngTemplateOutlet="affixTemplate"></ng-template>
</ng-container>
<ng-template #affixTemplate>
  <span class="ant-input-prefix" *ngIf="dwPrefix || dwPrefixIcon">
    <i [ngClass]="dwPrefixIcon" *ngIf="dwPrefixIcon"></i>
    <ng-container *ngIf="isPrefixString; else prefixTemplate">{{ dwPrefix }}</ng-container>
    <ng-template #prefixTemplate>
      <ng-template [ngTemplateOutlet]="dwPrefix"></ng-template>
    </ng-template>
  </span>
  <ng-template *ngTemplateOutlet="contentTemplate"></ng-template>
  <span class="ant-input-suffix" *ngIf="dwSuffix || dwSuffixIcon">
    <i [ngClass]="dwSuffixIcon" *ngIf="dwSuffixIcon"></i>
    <ng-container *ngIf="isSuffixString; else suffixTemplate">{{ dwSuffix }}</ng-container>
    <ng-template #suffixTemplate>
      <ng-template [ngTemplateOutlet]="dwSuffix"></ng-template>
    </ng-template>
  </span>
</ng-template>
<ng-template [ngIf]="isGroup" *ngTemplateOutlet="contentTemplate"></ng-template>
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>